import React from "react";
import { translate } from "../util/translations";

export const TranslationContext = React.createContext(translate());
